import { path } from 'ramda'


export const getParam = (paramName: string, props: any): string | null => {
  return path(['match', 'params', paramName], props) || null
}
